import React from 'react';
import { SiteSection, SiteSectionHeader } from '../../../../components/site';
import { platformDeviceManagement, platformWorkflow } from '../data/overview';

export const PlatformWorkflow: React.FC = () => (
  <>
    <SiteSection>
      <SiteSectionHeader
        title={platformWorkflow.title}
        subtitle={platformWorkflow.subtitle}
        align="center"
      />
      <ol className="platform-timeline">
        {platformWorkflow.steps.map((step, index) => (
          <li key={step.id} className="platform-timeline__step">
            <span className="platform-timeline__marker" aria-hidden>
              {step.id}
            </span>
            <div className="platform-timeline__content">
              <h3 className="platform-timeline__title">{step.title}</h3>
              <p className="platform-timeline__desc">{step.description}</p>
            </div>
            {index < platformWorkflow.steps.length - 1 ? (
              <span className="platform-timeline__connector" aria-hidden />
            ) : null}
          </li>
        ))}
      </ol>
    </SiteSection>

    <SiteSection id="device-management" tone="muted" className="platform-dm-section">
      <SiteSectionHeader
        title={platformDeviceManagement.title}
        subtitle={platformDeviceManagement.subtitle}
        align="center"
      />
      <ul className="platform-dm-list">
        {platformDeviceManagement.points.map((point) => (
          <li key={point}>{point}</li>
        ))}
      </ul>
    </SiteSection>
  </>
);
